import styles from './FAQ.module.scss'

interface FAQList {
  question: string
  questionText: string
  answer: string
  answerText: string
}

const FAQLists: FAQList[] = [
  {
    question: 'Q',
    questionText: '社内のプロジェクトチームにフィットするか不安なので、まずは話してみたい',
    answer: 'A',
    answerText:
      'プロジェクト提案時にUIデザイナーも直接会話させて頂きます。検討されているプロジェクトの課題感、期待含めてご相談いただき、一緒にプロジェクトがやれるかを判断していただければと思います。',
  },
  {
    question: 'Q',
    questionText: '依頼したい同種のサービスの過去実績を知りたい',
    answer: 'A',
    answerText:
      'B2C向けアプリ、管理画面、マイページ、ウェブサービスなど掲載されている以外にも豊富な過去実績がございます。詳細はお問い合わせ時にご案内させていただきます。',
  },
  {
    question: 'Q',
    questionText: 'UIデザイン後の開発まで依頼できますか？',
    answer: 'A',
    answerText:
      'はい、当社ではUIデザインから開発をシームレスに繋ぐところに強みを持っています。また開発工程を考慮したデザインが設計ができるのも当社の大きな特徴です。',
  },
  {
    question: 'Q',
    questionText: 'ワークショップのオンライン対応は可能ですか？',
    answer: 'A',
    answerText:
      'はい、現在多くのプロジェクトでのワークショップならびにユーザー調査はオンラインでの開催を実施しています。また内容に応じてオンラインとオフラインのハイブリッドでの実施も行っています。',
  },
]

const FAQ: React.VFC = () => {
  const FAQList = FAQLists.map(({ question, questionText, answer, answerText }) => (
    <div className={styles.section} key={questionText}>
      <div className={styles.FAQWrapper}>
        <div className={styles.questionWrapper}>
          <p className={styles.question}>{question}</p>
          <p className={styles.questionText}>{questionText}</p>
        </div>
        <div className={styles.answerWrapper}>
          <p className={styles.answer}>{answer}</p>
          <p className={styles.answerText}>{answerText}</p>
        </div>
      </div>
    </div>
  ))
  return (
    <>
      <section className={styles.FAQ} id="FAQ">
        <div className={styles.wrapper}>
          <div className={styles.textWrapper}>
            <p className={`${styles.redText} ${styles.introText}`}>FAQ</p>
            <p className={styles.p}>よくある質問</p>
          </div>
          <div className={styles.FAQList}>{FAQList}</div>
        </div>
      </section>
    </>
  )
}

export default FAQ
